/**
 * Hooks Entry Point
 *
 * Re-exports theme-related hooks for easier imports.
 * This allows consumers to import directly from the hooks directory:
 *
 * Example:
 * import { makeStyles } from "@geekyhawks/react-native-ui-components/theme/hooks";
 *
 * Author: Geeky Hawks FZE LLC
 */

export { makeStyles } from "./makeStyles";
